// @flow
import PrimaryPalette from '../../colors';

const Theme = {
  green: {
    foregroundColor: PrimaryPalette.darkGreen,
    backgroundColor: PrimaryPalette.lightGreen,
  },
  poppy: {
    foregroundColor: PrimaryPalette.darkPoppy,
    backgroundColor: PrimaryPalette.lightPoppy,
  },
  pale: {
    foregroundColor: PrimaryPalette.white,
    backgroundColor: PrimaryPalette.lightestGrey,
  },
};

export default Theme;
